import { useQuery } from "@tanstack/react-query";

import type {
  GetProductResponse,
  ListProductsResponse,
  PaginatedResponse,
  PaginationParams,
  ProductResource,
} from "@prequel/import-react";

import { importClient } from "./sdk/client";

import { type PageOptions, useAllPages, usePage } from "@/api/pagination";

export type { ProductResource } from "@prequel/import-react";

const routes = {
  list: "/import/products",
  get: (id: string) => `/import/products/${id}`,
};

const keys = { all: ["import", "products"] as const };

export const listProductsPage = (params: PaginationParams): Promise<PaginatedResponse<ProductResource[]>> =>
  importClient.getPaginated<ListProductsResponse>(routes.list, params).then((res) => ({
    data: res.data.products,
    has_next: res.has_next,
    next_url: res.next_url,
  }));

export function useListProducts(options?: PageOptions) {
  return usePage<ProductResource>([...keys.all], listProductsPage, options);
}

export function useAllImportProducts() {
  return useAllPages<ProductResource>([...keys.all], listProductsPage);
}

export function useProduct(id: string) {
  return useQuery({
    queryKey: [...keys.all, id],
    queryFn: () => importClient.get<GetProductResponse>(routes.get(id)).then((data) => data.product),
  });
}
